import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { FooterPageRoutingModule } from './footer-routing.module';

import { FooterPage } from './footer.page';
import { PipesModule } from 'src/app/shared/pipe/pipe.module';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from 'src/app/pages/menu/shared.module';
import { ComplementsFooterModule } from 'src/app/shared/components/complements-footer/complements-footer.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TranslateModule,
    FooterPageRoutingModule,
    PipesModule,
    SharedModule,
    ComplementsFooterModule
  ],
  declarations: [FooterPage],
  exports: [FooterPage]
})
export class FooterPageModule {}
